<template>
  <div
    class="service-area ptb--20 bg_color--5"
    v-bind:style="{ backgroundImage: 'url(' + src + ')' }"
  >
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="text-left section-title mb--10">
            <h2>{{ title }}</h2>
            <h2>
              <vue-typer
                :text="desc"
                :repeat="Infinity"
                :shuffle="false"
                initial-action="typing"
                :pre-type-delay="70"
                :type-delay="70"
                :pre-erase-delay="2000"
                :erase-delay="250"
                erase-style="select-all"
                :erase-on-complete="false"
                caret-animation="blink"
              ></vue-typer>
            </h2>
            <span class="text-center text-md-left">
              <a
                target="_blank"
                href="https://assistant.google.com/services/a/uid/0000002fc831fd88?hl=fr"
                ><img
                  alt="Works with Google"
                  v-bind:src="logo"
                  style="max-width:200px"
              /></a>
            </span>
          </div>
        </v-col>
        <v-col cols="12" class="align-content-center text-center "
          >* Cette invocation nécessite la création d'une routine sur votre
          assistant Google.<br />
          <a href="https://youtu.be/k9k7pWj52B0" target="_blank"
            >voir le mode d'emploi sur youtube</a
          >
        </v-col>
      </v-row>
      <!-- End .row -->
    </v-container>
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";
export default {
  components: {
    VueTyper
  },
  name: "banGoogle",
  data() {
    return {
      src: require("../../assets/images/bg/googlehome.jpeg"),
      title: "Ok Google,",
      desc: [
        `parler à mes amis de confiance`,
        `à l'aide!*`,
        `au secours!*`,
        `je suis tombé(e)!*`
      ],
      logo: require("../../assets/images/logo/logo_google.png")
    };
  }
};
</script>
<style scoped>
div {
  background-size: cover;
  background-repeat: no-repeat;
}
a {
  color: var(--color-gray) !important;
}
a:link {
  text-decoration: underline;
}
</style>
